import { Search } from '@mui/icons-material';
import {
  Autocomplete,
  Divider,
  List,
  ListItemButton,
  ListItemText,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React from 'react';
import { FinsightEntity } from 'shared';

type CreateEntityProps = {
  type: string;
  parent?: FinsightEntity;
  moreClicked?: boolean;
};

export function CreateEntityModalMore(_props: CreateEntityProps) {
  return (
    <Stack py={1}>
      <Typography variant="h5">Entity Types</Typography>
      <Typography>
        Entities in finsight can have ANY type. Although finsight does provide
        some basic types such as group, item, and project, you can create your
        own custom types with their own fields and functionality.
      </Typography>
      <Divider sx={{ my: 1 }} />
      <Stack mt={2} direction="row" justifyContent="stretch" gap={1}>
        <Stack minWidth={300} overflow="auto">
          <Autocomplete
            sx={{ pt: 1 }}
            freeSolo
            size="small"
            options={[]}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Entity Types"
                InputProps={{
                  ...params.InputProps,
                  startAdornment: <Search fontSize="small" color="primary" />,
                }}
              />
            )}
          />
          <List dense>
            <Typography
              color="text.secondary"
              textTransform="uppercase"
              variant="body2"
              my={1}
              fontWeight="bold"
            >
              Premade Types
            </Typography>
            <ListItemButton>
              <ListItemText primary="Group" />
            </ListItemButton>
            <ListItemButton>
              <ListItemText primary="Item" />
            </ListItemButton>
            <Typography
              color="text.secondary"
              textTransform="uppercase"
              variant="body2"
              fontWeight="bold"
              my={1}
            >
              Types from plugins
            </Typography>
            <ListItemButton>
              <ListItemText primary="Project" />
            </ListItemButton>
            <ListItemButton>
              <ListItemText primary="Task" />
            </ListItemButton>
            <ListItemButton>
              <ListItemText primary="Transaction" />
            </ListItemButton>
            <ListItemButton>
              <ListItemText primary="Commodity" />
            </ListItemButton>
          </List>
        </Stack>
        <Stack>
          <Divider orientation="vertical" />
        </Stack>
        <Stack flexGrow={1}>
          <Typography>Fields</Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}
